import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import type React from 'react';

import { muiTheme } from './muiTheme.js';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider(props: ThemeProviderProps) {
  return <MuiThemeProvider theme={muiTheme}>{props.children}</MuiThemeProvider>;
}

ThemeProvider.displayName = 'ThemeProvider';
